<template>
  <div class="search-by-connections">
    <b-form-checkbox
      v-model="max_number_of_connections"
      id="checkbox-max_number_of_connections"
      name="checkbox-max_number_of_connections"
      value="0"
      unchecked-value="2"
      @change="handle_change"
    >
      Solo voli diretti
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: 'search-by-connections',
  created() {
    document.body.classList.remove('overflow-hidden');
  },
  computed: {
    max_number_of_connections: {
      get() {
        return this.$store.state.liveflight.max_number_of_connections !== undefined
          ? this.$store.state.liveflight.max_number_of_connections
          : 0;
      },
      set(value) {
        this.$store.commit('max_number_of_connections', value);
      },
    },
  },
  methods: {
    handle_change() {
      this.log('[CHANGE]: max_number_of_connections = ' + this.max_number_of_connections);
      window.eventBus.$emit('change-search-by', {
        max_number_of_connections: this.max_number_of_connections,
      });
    },
  },
};
</script>

<style lang="scss">
.search-by-connections {
  @include liveflight-checkbox;
}
</style>
